import { Inject, Injectable, Optional } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';

import { FormField } from '@services';
import { AddFolderParameters, IFolder } from './../model/folders.interfaces';
import { AddFolderComponent } from '@modules/management/modules/folders/components';
import { FilterData } from '@shared/modules/menu-filter/services/filter-menu.service';
import { FOLDER_FACTORY_SERVICE_TOKEN, FolderFactoryService } from './folder-factory.service';
import { IPopoverConfig } from '@modules/shared/components/popoverTemplate/popover-template.component';

import { each, has } from 'lodash';

@Injectable()
export class FoldersService {
  constructor(
    private navController: NavController,
    private modalController: ModalController,
    @Optional() @Inject(FOLDER_FACTORY_SERVICE_TOKEN) private folderFactory: FolderFactoryService
  ) {}

  public async openFolderView(parameters: AddFolderParameters) {
    // Pre-load any required data before opening the modal
    if (this.folderFactory?.preloadData) {
      await this.folderFactory.preloadData();
    }

    const modal = await this.modalController.create({
      component: AddFolderComponent,
      cssClass: 'fullscreen-modal',
      backdropDismiss: false,
      componentProps: {
        inputParameters: parameters
      }
    });
    await modal.present();
  }

  public goToFolder(link: string, folderId: number): void {
    this.navController.navigateForward([`pages/management/${link}`, {folderId}], { animated: false });
  }

  public filterData(folderData: IFolder): void {
    this.folderFactory?.prepareDataBeforeRender?.(folderData);
  }

  public checkAndUpdateSaveDialog(folderData: IFolder, folderID: number, updatePopoverConfig: IPopoverConfig): void {
    this.folderFactory?.checkAndUpdateSaveDialog?.(folderData, folderID, updatePopoverConfig);
  }

  public integrateParentAttributes(folderData: IFolder, parentFolderData: IFolder): void {
    this.folderFactory?.integrateParentAttributes?.(folderData, parentFolderData);
  }

  public getAdditionFields(folderData?: IFolder): FormField[] {
    return (this.folderFactory?.getFields?.(folderData)) ?? [];
  }

  public onFinishRenderAddFolderForm(formConfig) {
    this.folderFactory?.onFinishRenderAddFolderForm?.(formConfig);
  }

  public parseFormData(formData: any) {
    const fieldNames: string[] = [];

    each(this.getAdditionFields(), item => {
      if (item?.name) {
        fieldNames.push(item.name);
      }
    });

    each(fieldNames, (fieldName) => {
      if (has(formData, fieldName)) {
        try {
          formData[fieldName] = JSON.parse(formData[fieldName]);
        } catch (error) {}
      }
    });

    // Allow factory to normalize form data after parsing
    this.folderFactory?.normalizeFormData?.(formData);
  }

  public getFilterData() {
    return this.folderFactory?.filterData;
  }

  public saveFilterData(data: FilterData) {
    if (this.folderFactory) {
      this.folderFactory.filterData = data;
    }
  }
}
